module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page pageHero yellow"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "img"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-content"
  }, [_c('h2', [_vm._v("Error 404! File not found.")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("We couldn’t find the page you’re looking for. Try going "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_vm._v("home")]), _vm._v(" or using "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Search'
      }
    }
  }, [_vm._v("search.")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b4d7d07"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
// module id = 762
// module chunks = 1